import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Rhombus with diagonal feature.
 *
 * Verifiable properties:
 * - Diagonals are perpendicular
 * - Diagonals bisect each other
 * - d1² + d2² = 4s²
 */
export const RHOMBUS_FEATURES_PRESET: GeometryPadWidgetConfig = {
  id: 'rhombus-features',
  type: 'geometrypad',
  params: {
    elements: {
      rh1: {
        type: 'Rhombus',
        params: { s: 5, angle: 60 },
      },
      'diagonal.rh1': { type: 'Diagonal', params: { of: 'rh1' } },
    },
  },
  display: {},
};
